module.exports = __webpack_public_path__ + "static/media/share.136a4265.svg";